import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoCheckAutomatic, LazySvgoCheckManual, LazySvgoEditDate, LazySvgoFinalizeAll, LazySvgoGanttChart, LazySvgoGridOn, LazySvgoLightingBoltCity, LazySvgoLightingBoltHome, LazySvgoNetDiagram, LazySvgoNetDiagramColoring, LazySvgoNetDiagramOnly, LazySvgoTransmissionTowerBolt, LazySvgoInactiveCalendar, LazySvgoInactiveCheckBoxIndeterminate, LazySvgoInactiveEditDate, LazySvgoInactiveGruppe210, LazySvgoInactiveGruppe211, LazySvgoInactiveGruppe214, LazySvgoInactiveGruppe215, LazySvgoInactiveSwapHorizontal, LazySvgoInactiveViewColumn2, LazySvgoInactiveViewRows2, LazySvgoInactiveViewSingle, LazySvgoInactiveWarning, LazySvgoInactiveActive, LazySvgoInactiveArrowDownward, LazySvgoInactiveArrowDropDown, LazySvgoInactiveArrowRightAlt, LazySvgoInactiveBack, LazySvgoInactiveCheck, LazySvgoInactiveCheckBoxChecked, LazySvgoInactiveCheckBoxOutlineBlank, LazySvgoInactiveClose, LazySvgoInactiveDelete, LazySvgoInactiveFile, LazySvgoInactiveFileDownload, LazySvgoInactiveFileUpload, LazySvgoInactiveFilter, LazySvgoInactiveFinalize, LazySvgoInactiveFinalizeAll, LazySvgoInactiveGanttChart, LazySvgoInactiveGridOn, LazySvgoInactiveKeyboardArrowDown, LazySvgoInactiveLogout1, LazySvgoInactiveLogout, LazySvgoInactiveMoreVert, LazySvgoInactiveNetDiagram, LazySvgoInactiveNetDiagramOnly, LazySvgoInactiveOpenInNew, LazySvgoInactiveRadioButtonChecked, LazySvgoInactiveRadioButtonUnchecked, LazySvgoInactiveRename, LazySvgoInactiveRestore, LazySvgoInactiveScreenCopy, LazySvgoInactiveSearch, LazySvgoInactiveSettings, LazySvgoInactiveSkipNext, LazySvgoInactiveSkipPrev, LazySvgoInactiveStarBorder, LazySvgoInactiveStarFilled, LazySvgoInactiveSwapVert, LazySvgoInactiveTable, LazySvgoInactiveToday, LazySvgoInactiveTune, LazySvgoInactiveZoomIn } from '#components'
const lazyGlobalComponents = [
  ["SvgoCheckAutomatic", LazySvgoCheckAutomatic],
["SvgoCheckManual", LazySvgoCheckManual],
["SvgoEditDate", LazySvgoEditDate],
["SvgoFinalizeAll", LazySvgoFinalizeAll],
["SvgoGanttChart", LazySvgoGanttChart],
["SvgoGridOn", LazySvgoGridOn],
["SvgoLightingBoltCity", LazySvgoLightingBoltCity],
["SvgoLightingBoltHome", LazySvgoLightingBoltHome],
["SvgoNetDiagram", LazySvgoNetDiagram],
["SvgoNetDiagramColoring", LazySvgoNetDiagramColoring],
["SvgoNetDiagramOnly", LazySvgoNetDiagramOnly],
["SvgoTransmissionTowerBolt", LazySvgoTransmissionTowerBolt],
["SvgoInactiveCalendar", LazySvgoInactiveCalendar],
["SvgoInactiveCheckBoxIndeterminate", LazySvgoInactiveCheckBoxIndeterminate],
["SvgoInactiveEditDate", LazySvgoInactiveEditDate],
["SvgoInactiveGruppe210", LazySvgoInactiveGruppe210],
["SvgoInactiveGruppe211", LazySvgoInactiveGruppe211],
["SvgoInactiveGruppe214", LazySvgoInactiveGruppe214],
["SvgoInactiveGruppe215", LazySvgoInactiveGruppe215],
["SvgoInactiveSwapHorizontal", LazySvgoInactiveSwapHorizontal],
["SvgoInactiveViewColumn2", LazySvgoInactiveViewColumn2],
["SvgoInactiveViewRows2", LazySvgoInactiveViewRows2],
["SvgoInactiveViewSingle", LazySvgoInactiveViewSingle],
["SvgoInactiveWarning", LazySvgoInactiveWarning],
["SvgoInactiveActive", LazySvgoInactiveActive],
["SvgoInactiveArrowDownward", LazySvgoInactiveArrowDownward],
["SvgoInactiveArrowDropDown", LazySvgoInactiveArrowDropDown],
["SvgoInactiveArrowRightAlt", LazySvgoInactiveArrowRightAlt],
["SvgoInactiveBack", LazySvgoInactiveBack],
["SvgoInactiveCheck", LazySvgoInactiveCheck],
["SvgoInactiveCheckBoxChecked", LazySvgoInactiveCheckBoxChecked],
["SvgoInactiveCheckBoxOutlineBlank", LazySvgoInactiveCheckBoxOutlineBlank],
["SvgoInactiveClose", LazySvgoInactiveClose],
["SvgoInactiveDelete", LazySvgoInactiveDelete],
["SvgoInactiveFile", LazySvgoInactiveFile],
["SvgoInactiveFileDownload", LazySvgoInactiveFileDownload],
["SvgoInactiveFileUpload", LazySvgoInactiveFileUpload],
["SvgoInactiveFilter", LazySvgoInactiveFilter],
["SvgoInactiveFinalize", LazySvgoInactiveFinalize],
["SvgoInactiveFinalizeAll", LazySvgoInactiveFinalizeAll],
["SvgoInactiveGanttChart", LazySvgoInactiveGanttChart],
["SvgoInactiveGridOn", LazySvgoInactiveGridOn],
["SvgoInactiveKeyboardArrowDown", LazySvgoInactiveKeyboardArrowDown],
["SvgoInactiveLogout1", LazySvgoInactiveLogout1],
["SvgoInactiveLogout", LazySvgoInactiveLogout],
["SvgoInactiveMoreVert", LazySvgoInactiveMoreVert],
["SvgoInactiveNetDiagram", LazySvgoInactiveNetDiagram],
["SvgoInactiveNetDiagramOnly", LazySvgoInactiveNetDiagramOnly],
["SvgoInactiveOpenInNew", LazySvgoInactiveOpenInNew],
["SvgoInactiveRadioButtonChecked", LazySvgoInactiveRadioButtonChecked],
["SvgoInactiveRadioButtonUnchecked", LazySvgoInactiveRadioButtonUnchecked],
["SvgoInactiveRename", LazySvgoInactiveRename],
["SvgoInactiveRestore", LazySvgoInactiveRestore],
["SvgoInactiveScreenCopy", LazySvgoInactiveScreenCopy],
["SvgoInactiveSearch", LazySvgoInactiveSearch],
["SvgoInactiveSettings", LazySvgoInactiveSettings],
["SvgoInactiveSkipNext", LazySvgoInactiveSkipNext],
["SvgoInactiveSkipPrev", LazySvgoInactiveSkipPrev],
["SvgoInactiveStarBorder", LazySvgoInactiveStarBorder],
["SvgoInactiveStarFilled", LazySvgoInactiveStarFilled],
["SvgoInactiveSwapVert", LazySvgoInactiveSwapVert],
["SvgoInactiveTable", LazySvgoInactiveTable],
["SvgoInactiveToday", LazySvgoInactiveToday],
["SvgoInactiveTune", LazySvgoInactiveTune],
["SvgoInactiveZoomIn", LazySvgoInactiveZoomIn],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
